import { render, staticRenderFns } from "./MedicationSensitivityInfo.vue?vue&type=template&id=6bc53093"
import script from "./MedicationSensitivityInfo.vue?vue&type=script&lang=js"
export * from "./MedicationSensitivityInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports